<template>
  <div>
    <b-card title="ESTUDIANTE">
      <div>
        <b-row>
          <b-col md="5"></b-col>
          <b-col md="2">
            <b-img rounded="circle" thumbnail :src="mainPath+url" fluid/>
          </b-col>
          <b-col md="5"></b-col>
        </b-row>
        <br>
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="fa fa-chevron-right"></i>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-file @change="processFile($event)" v-model="img_student" accept=".jpg, .png"></b-form-file>
          </b-input-group>
        </b-form-group>

        <b-form-group label-for label="Tipo de documento">
          <b-form-select :options="type_documents" v-model="type_document"></b-form-select>
        </b-form-group>
        <b-form-group label="No.identificacion">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="fa fa-chevron-right"></i>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" v-model="number_doc"></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Nombre">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="fa fa-chevron-right"></i>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" v-model="name"></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Email">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="fa fa-chevron-right"></i>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" v-model="email"></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Fecha nacimiento">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="fa fa-calendar"></i>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="date" v-model="birthday"></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Direccion">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="fa fa-chevron-right"></i>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" v-model="address"></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Telefono">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="fa fa-hashtag"></i>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="tel" v-model="phone"></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Celular">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="fa fa-hashtag"></i>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="tel" v-model="cellphone"></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group label-for label="Horario Alumno">
          <b-form-select :options="selected_turns" v-model="horario"></b-form-select>
        </b-form-group>
        <b-row class="text-center">
          <b-col>
            <div>
              <b-form-group label="Producto">
                <b-btn
                  v-if="!selected_products.name"
                  variant="success"
                  @click="getProducts"
                >Seleccionar Productos</b-btn>
                <h3>
                  <b-badge
                    href="#"
                    variant="primary"
                    @click="getProducts"
                  >{{selected_products.name}}</b-badge>
                </h3>
              </b-form-group>
            </div>
          </b-col>
          <b-col>
            <div>
              <b-form-group label="Curso">
                <b-btn
                  v-if="!selected_course.name"
                  variant="success"
                  @click="getAllCourses"
                >Seleccionar Curso</b-btn>
                <h3>
                  <b-badge
                    href="#"
                    variant="primary"
                    @click="getAllCourses"
                  >{{selected_course.name}}</b-badge>
                </h3>
              </b-form-group>
            </div>
          </b-col>
          <b-col>
            <div>
              <b-form-group label="Acudiente">
                <b-btn
                  v-if="!selected_attendant.name"
                  variant="success"
                  @click="getAttendants"
                >Seleccionar Acudiente</b-btn>
                <h3>
                  <b-badge
                    href="#"
                    variant="primary"
                    @click="getAttendants"
                  >{{selected_attendant.name}}</b-badge>
                </h3>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <gmap-autocomplete @place_changed="setPlace" style="width: 100%;"></gmap-autocomplete>
          <br>
          <gmap-map ref="mymap" :center="center" :zoom="15" style="width: 100%; height: 300px">
            <gmap-marker :position="center" :draggable="true" @drag="updateCoordinates"/>
          </gmap-map>
        </b-row>
        <b-row>
          <b-col class="text-center">
            <b-btn variant="danger" @click="createStudent">Guardar</b-btn>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal ref="modalCourse" size="lg" id="modal-course" centered title="Cursos creados">
      <b-container>
        <b-row class="mb-1 text-center">
          <b-col cols="3">
            <b-form-input v-model="filter_courses" placeholder="Buscar curso"/>
          </b-col>
          <b-col>
            <b-table
              show-empty
              :small="true"
              :fixed="true"
              :striped="true"
              :bordered="true"
              :current-page="currentPage_courses"
              :items="options"
              :fields="fields"
              :filter="filter_courses"
              :per-page="perPage"
              @filtered="onFiltered_courses"
            >
              <template slot="actions" slot-scope="row">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-button
                  size="sm"
                  variant="success"
                  @click.stop="selectCourse(row.item, row.index, $event.target)"
                  class="mr-1"
                >Seleccionar</b-button>
              </template>
            </b-table>
            <b-pagination
              :total-rows="totalRows_courses"
              :per-page="perPage"
              v-model="currentPage_courses"
              class="my-0"
            />
          </b-col>
        </b-row>
      </b-container>
    </b-modal>

    <b-modal ref="modalAttendant" size="lg" id="modal-attendant" centered title="Acudientes">
      <b-container>
        <b-row class="mb-1 text-center">
          <b-col cols="3">
            <b-form-input v-model="filter_attendant" placeholder="Buscar Acudiente"/>
            <br>
            <b-btn variant="success" size="sm" block @click="newAttendant">agregar nuevo</b-btn>
          </b-col>
          <b-col>
            <b-table
              show-empty
              :small="true"
              :fixed="true"
              :striped="true"
              :bordered="true"
              :current-page="currentPage_attendant"
              :items="attendant"
              :fields="fields_attendant"
              :filter="filter_attendant"
              :per-page="perPage"
              @filtered="onFiltered_attendant"
            >
              <template slot="actions" slot-scope="row">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-button
                  size="sm"
                  variant="success"
                  @click.stop="selectAttendant(row.item, row.index, $event.target)"
                  class="mr-1"
                >Seleccionar</b-button>
              </template>
                    </b-table>
                    <b-pagination :total-rows='totalRows_attendant' :per-page='perPage' v-model='currentPage_attendant' class='my-0' />
                </b-col>
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref='modalProducts' size='lg' id='modal-products' centered title='Productos'>
        <b-container>
            <b-row class='mb-1 text-center'>
                <b-col cols='3'>
                    <b-form-input v-model='filter_products' placeholder='Buscar curso' />
                </b-col>
                <b-col>
                    <b-table show-empty :small='true' :fixed='true' :striped='true' :bordered='true' :current-page='currentPage_products' :items='products' :fields='fields' :filter='filter_products' :per-page='perPage' @filtered='onFiltered_products'>
<template slot='actions' slot-scope='row'>
  <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
  <b-button
    size="sm"
    variant="success"
    @click.stop="selectProducts(row.item, row.index, $event.target)"
    class="mr-1"
  >Seleccionar</b-button>
</template>
                    </b-table>
                    <b-pagination :total-rows='totalRows_products' :per-page='perPage' v-model='currentPage_products' class='my-0' />
                </b-col>
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref='modalNewAttendant' size='lg' id='modal-products' centered title='Nuevo Acudiente' @ok='saveAttendant' ok-title='Guardar' cancel-title='Cerrar'>
        <b-container>
            <b-form-group label-for='' label='Tipo de documento'>
                <b-form-select  :options='type_documents' v-model='type_document_attendant'></b-form-select>
            </b-form-group>
            <b-form-group label='No.identificacion'>
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class='fa fa-chevron-right'></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type='text' v-model='document_attendant'></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group label='Nombre'>
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class='fa fa-chevron-right'></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type='text' v-model='name_attendant'></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group label='Email'>
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class='fa fa-chevron-right'></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type='email' v-model='email_attendant'></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group label='Fecha nacimiento'>
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class='fa fa-calendar'></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type='date' v-model='birthday_attendant'></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group label='Direccion'>
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class='fa fa-chevron-right'></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type='text' v-model='address_attendant'></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group label='Telefono'>
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class='fa fa-hashtag'></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type='tel' v-model='phone_attendant'></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group label='Celular'>
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class='fa fa-hashtag'></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type='tel' v-model='cellphone_attendant'></b-form-input>
                </b-input-group>
            </b-form-group>
        </b-container>
    </b-modal>
</div>
</template>

<script>
const type_documents = [
  {
    value: null,
    text: "Seleccione documentos"
  },
  {
    value: 1,
    text: "Cedula de ciudadania"
  },
  {
    value: 2,
    text: "NIT"
  },
  {
    value: 3,
    text: "Pasaporte"
  },
  {
    value: 4,
    text: "Tarjeta de Identidad"
  },
  {
    value: 5,
    text: "Registro Civil"
  },
  {
    value: 6,
    text: "Nuip"
  },
  {
    value: 7,
    text: "Cedula de Extranjería"
  }
];
const fields = [
  {
    key: "name",
    label: "Nombre"
  },
  {
    key: "actions",
    label: "Accion"
  }
];
const fields_attendant = [
  {
    key: "name",
    label: "Nombre"
  },
  {
    key: "document",
    label: "Documento"
  },
  {
    key: "actions",
    label: "Accion"
  }
];
export default {
  name: "edit",
  data() {
    return {
      fields: fields,
      fields_attendant: fields_attendant,
      type_documents: type_documents,
      options: [],
      course: {},
      center: {},
      attendant: {},
      products: {},
      coordinates: {},
      selected_course: {},
      selected_attendant: {},
      selected_products: {},
      selected_turns: {},
      filter_courses: "",
      filter_attendant: "",
      filter_products: "",
      currentPage_attendant: 1,
      currentPage_products: 1,
      currentPage_courses: 1,
      perPage: 5,
      totalRows_courses: 0,
      totalRows_attendant: 0,
      totalRows_products: 0,
      type_document: null,
      horario: null,
      name: "",
      img_student: null,
      number_doc: "",
      birthday: "",
      address: "",
      phone: "",
      email: "",
      cellphone: "",
      type_document_attendant: "",
      document_attendant: "",
      name_attendant: "",
      birthday_attendant: "",
      address_attendant: "",
      phone_attendant: "",
      cellphone_attendant: "",
      email_attendant: "",
      mainPath: "",
      url: ""
    };
  },
  mounted() {
    this.getAllData();
    this.getLocation();
    this.getTurns();
    this.mainPath = localStorage.getItem("urlApi");
    this.mainPath = this.mainPath.replace("/api", "");
  },
  methods: {
    setPlace(place) {
      let lat = place.geometry.location.lat();
      let lng = place.geometry.location.lng();
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
    },
    getLocation() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    getTurns() {
      let array = [
        {
          value: null,
          text: "Seleccione horario"
        }
      ];
      this.$store.dispatch("controlaccesoturnslist").then(response => {
        let items = this.$store.getters.controlaccesoturns.items;
        console.log("compoentes, ", items);
        items.forEach(data => {
          let opt = {
            value: data.id,
            text: data.name
          };
          array.push(opt);
        });
      });
      this.selected_turns = array;
    },
    updateCoordinates(location) {
      this.coordinates = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };
    },
    getAllCourses() {
      let self = this;
      this.$store
        .dispatch("academicCoursesAll")
        .then(response => {
          self.options = this.$store.getters.academicCourse.items;
          self.totalRows_courses = self.options.length;
          this.$refs.modalCourse.show();
        })
        .catch(error => {
          this.$root.showInfoDialog(
            "Mensaje informativo",
            "Ocurrio un error, intente nuevamente",
            "Aceptar"
          );
        });
    },
    getAllData() {
      let data = {
        id: this.$route.params.id
      };
      this.$store
        .dispatch("academicStudentEdit", data)
        .then(response => {
          let user = this.$store.getters.academicStudents.formData;
          this.type_document = user.type_doc;
          this.number_doc = user.num_doc;
          this.name = user.name;
          this.email = user.email;
          this.birthday = user.fechaNacimiento;
          this.address = user.address;
          this.phone = user.phone;
          this.cellphone = user.cellphone;
          this.url = user.url;
          this.horario = user.turno
          let pos = new google.maps.LatLng(user.latitud, user.longitud);
          this.center = pos;
          this.coordinates = pos;
          if (user.products) {
            this.selected_products = user.products;
          }
          if (user.curso) {
            this.selected_course = user.curso;
          }
          if (user.acudiente) {
            this.selected_attendant = user.acudiente;
          }
        })
        .catch(error => {
          this.$root.showInfoDialog(
            "Mensaje informativo",
            "Ocurrio un error, intente nuevamente",
            "Aceptar"
          );
        });
    },
    getAttendants() {
      let self = this;
      this.$store
        .dispatch("academicAttendantAll")
        .then(response => {
          self.attendant = this.$store.getters.academicAttendant.items;
          self.totalRows_attendant = self.options.length;
          this.$refs.modalAttendant.show();
        })
        .catch(error => {
          this.$root.showInfoDialog(
            "Mensaje informativo",
            "Ocurrio un error, intente nuevamente " + error,
            "Aceptar"
          );
        });
    },
    getProducts() {
      if (!this.birthday) {
        this.$root.showInfoDialog(
          "Mensaje Informativo",
          "La fecha de nacimiento debe ser ingresada para poder ver esta seccion.",
          "Aceptar"
        );
        return;
      }
      let data = {
        birthday: this.birthday
      };
      let self = this;
      this.$store
        .dispatch("academicStudentProduct", data)
        .then(response => {
          self.products = this.$store.getters.academicStudents;
          self.totalRows_products = self.options.length;
          console.log("aaa", this.$store.getters.academicStudents);
          this.$refs.modalProducts.show();
        })
        .catch(error => {
          this.$root.showInfoDialog(
            "Mensaje informativo",
            "Ocurrio un error, intente nuevamente " + error,
            "Aceptar"
          );
        });
    },
    newAttendant() {
      this.$refs.modalAttendant.hide();
      this.$refs.modalNewAttendant.show();
    },
    saveAttendant() {
      let data = {
        type_doc: this.type_document_attendant,
        num_doc: this.document_attendant,
        name: this.name_attendant,
        fechaNacimiento: this.birthday_attendant,
        address: this.address_attendant,
        phone: this.phone_attendant,
        cellphone: this.cellphone_attendant,
        email: this.email_attendant
      };
      let self = this;
      this.$store
        .dispatch("academicAttendantCreate", data)
        .then(response => {
          self.attendant = this.$store.getters.academicAttendant;
          this.$refs.modalAttendant.hide();
        })
        .catch(error => {
          this.$root.showInfoDialog(
            "Mensaje informativo",
            "Ocurrio un error, intente nuevamente " + error,
            "Aceptar"
          );
        });
    },
    getBase64: function(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function() {
          resolve(reader.result);
        };
        reader.onerror = function(error) {
          console.log("Error: ", error);
          resolve("");
        };
      });
    },
    createStudent() {
      if (!this.type_document) {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "El campo  <strong>Tipo de documento</strong> es requerido",
          "Aceptar"
        );
        return;
      }
      if (!this.number_doc) {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "El campo  <strong>No. Identificacion</strong> es requerido",
          "Aceptar"
        );
        return;
      }
      if (!this.name) {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "El campo  <strong>Nombre</strong> es requerido",
          "Aceptar"
        );
        return;
      }
      if (!this.birthday) {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "El campo  <strong>Fecha de nacimiento</strong> es requerido",
          "Aceptar"
        );
        return;
      }

      if (!this.email || !this.email.includes("@")) {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "El campo  <strong>Email</strong> es requerido",
          "Aceptar"
        );
        return;
      }

      if (!this.address) {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "El campo  <strong>Direccion</strong> es requerido",
          "Aceptar"
        );
        return;
      }

      if (!this.phone) {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "El campo  <strong>Telefono</strong> es requerido",
          "Aceptar"
        );
        return;
      }

      if (!this.cellphone) {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "El campo  <strong>Celular</strong> es requerido",
          "Aceptar"
        );
        return;
      }

      if (!this.selected_products.name) {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "El  <strong>Producto por defecto</strong> es requerido",
          "Aceptar"
        );
        return;
      }

      if (!this.selected_course.name) {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "El  <strong>Curso</strong> es requerido",
          "Aceptar"
        );
        return;
      }

      if (!this.horario) {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "El  <strong>Horario</strong> es requerido",
          "Aceptar"
        );
        return;
      }

      if (!this.selected_attendant.name) {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "El  <strong>Acudiente</strong> es requerido",
          "Aceptar"
        );
        return;
      }
      if (this.img_student != null) {
        this.getBase64(this.img_student).then(response => {
          let data = {
            id: this.$route.params.id,
            type_doc: this.type_document,
            num_doc: this.number_doc,
            name: this.name,
            email: this.email,
            fechaNacimiento: this.birthday,
            address: this.address,
            phone: this.phone,
            cellphone: this.cellphone,
            turno: this.horario,
            productodefault: this.selected_products.id,
            select_course: this.selected_course.id,
            latitud: this.coordinates.lat,
            longitud: this.coordinates.lng,
            select_attendant: this.selected_attendant.id,
            image: response
          };
          this.sendToServer(data);
        });
      } else {
        let data = {
          id: this.$route.params.id,
          type_doc: this.type_document,
          num_doc: this.number_doc,
          name: this.name,
          email: this.email,
          fechaNacimiento: this.birthday,
          address: this.address,
          phone: this.phone,
          cellphone: this.cellphone,
          turno: this.horario,
          productodefault: this.selected_products.id,
          select_course: this.selected_course.id,
          select_attendant: this.selected_attendant.id,
          latitud: this.coordinates.lat,
          longitud: this.coordinates.lng
        };
        this.sendToServer(data);
      }
    },
    sendToServer(data) {
      this.$store
        .dispatch("academicStudentUpdate", data)
        .then(response => {
          let resp = this.$store.getters.academicStudents;
          let status = this.$store.getters.academicStudents.code;
          if (status != 0) {
            this.$root.showInfoDialog(
              "Mensaje informativo",
              "Estudiante creado correctamente",
              "Aceptar"
            );
            this.$router.push("/academic/students");
          } else {
            let message = "Encontramos un error: <br> ";
            if (resp.data.num_doc) {
              message +=
                "El <strong>numero de documento</strong> ya se encuentra registrado <br>";
            }

            if (resp.data.email) {
              message +=
                "El <strong>email</strong> ya se encuentra registrado <br>";
            }
            this.$root.showInfoDialog(
              "Mensaje informativo",
              message,
              "Aceptar"
            );
          }
        })
        .catch(error => {
          this.$root.showInfoDialog(
            "Mensaje informativo",
            "Error creando estudiante " + error,
            "Aceptar"
          );
        });
    },
    selectCourse(item, key) {
      this.$refs.modalCourse.hide();
      this.selected_course = item;
    },
    selectAttendant(item, key) {
      this.$refs.modalAttendant.hide();
      this.selected_attendant = item;
    },
    selectProducts(item, key) {
      this.$refs.modalProducts.hide();
      this.selected_products = item;
    },
    onFiltered_courses(filteredItems) {
      this.totalRows_courses = filteredItems.length;
      this.currentPage_courses = 1;
    },
    onFiltered_attendant(filteredItems) {
      this.totalRows_courses = filteredItems.length;
      this.currentPage_attendant = 1;
    },
    onFiltered_products(filteredItems) {
      this.totalRows_products = filteredItems.length;
      this.currentPage_products = 1;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/academic/students/edit.vue